module.exports = __webpack_public_path__ + "7e3f87483963dfc767bf4cbb786cf4c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/docs/zip-upload/zip-upload-1.png
// module id = 2479
// module chunks = 0